import {
    getDataApi,
    postDataApi,
    putDataApi,
} from '../utils/fech-api';

export const BASE_URL_CATEGORIES = '/api/categories'; 
const BASE_URL_Manage = '/api/admin/categories'; 

// Fetch all posts
export const fetchCategories = async (params = {}, headers = {}) => {
    return await getDataApi(BASE_URL_CATEGORIES, headers, params);
};

// Fetch a single category by ID
export const fetchCategoryById = async (categoryId, params = {}, headers = {}) => {
    const resp = await getDataApi(`${BASE_URL_CATEGORIES}/${categoryId}`, headers, params);
    return resp.data;
};

// Create a new post
export const createCategory = (postData, headers = {}) => {
    return postDataApi(BASE_URL_Manage, postData, headers);
};

// Update a post (PUT request)
export const updateCategory = (postId, updatedData, headers = {}) => {
    return putDataApi(`${BASE_URL_Manage}/${postId}`, updatedData, headers);
};

